// Base URL for API requests
// Resolution order:
//   1. REACT_APP_API_URL  — baked in at build time (see frontend/.env)
//   2. localhost during local dev
//   3. deployed backend fallback

const getApiUrl = () => {
  const configured = process.env.REACT_APP_API_URL;
  if (configured) {
    return configured.replace(/\/+$/, "");
  }

  const hostname = window.location.hostname;

  if (hostname.includes("localhost") || hostname.includes("127.0.0.1")) {
    return "http://localhost:8000"; // Local backend
  }

  return "https://ada-compliance-backend-218319277447.us-central1.run.app";
};

export const BASE_URL = getApiUrl();
